<template>
  <div v-if="task">
    <task-body :task="task" :try-join="tryJoin" :try-leave="tryLeave" />
    <box>
      <h3 class="mb-5">{{ $tc('reward', 2) }}</h3>
      <rewards-list
        :type="task.title"
        :rewards="task.subTasks"
        disabled-limits
      />
    </box>
    <b-modal
      ref="beforeJoinModal"
      centered
      header-hide
      ok-title="Send request"
      @ok="join"
    >
      <b-form>
        <b-form-group label="Sub-tasks:">
          <multi-select
            btn-label="Sub-tasks"
            size="lg"
            :options="{ multi: true }"
            :select-options="[
              'Whitepaper',
              'Main website translate',
              'ICO website translate',
              'BitcoinTalk ANN Thread',
              'Bounty thread',
              'One pager',
              'Lightpaper',
              'Moderation'
            ]"
          />
        </b-form-group>
        <b-form-group label="Languages to translate:">
          <multi-select
            btn-label="Languages"
            size="lg"
            :options="{ multi: true }"
            :select-options="['English', 'Russian', 'Estonian']"
          />
        </b-form-group>
        <b-form-group label="Link to your portfolio:">
          <b-form-input type="text" size="lg" required />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';
import RewardsList from '@/views/Campaign/BountyCampaign/components/RewardsList.vue';

export default {
  mixins: [taskMixin],

  components: {
    RewardsList
  },

  methods: {
    tryJoin() {
      Promise.resolve(true).then(res => {
        if (res) this.$refs.beforeJoinModal.show();
        else this.showReject();
      });
    },
    join(e) {
      e.preventDefault();
      // TODO: add spiner when request is status sending
      Promise.resolve(true).then(res => {
        if (res) {
          this.$refs.beforeJoinModal.hide();
          this.$bus.$emit('modal:info', {
            title:
              'Thank You. Our Manager is going to check the application and You will receive an email with further details.',
            size: 'md'
          });
        } else {
          // TODO: show errors
        }
      });
    }
  }
};
</script>
